export default __webpack_public_path__ + "static/media/image-cushion-b-w@2x.0a5b7bf0.png";